import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {ScheduleTimePresenter} from "./scheduleTimePresenter";
import TimeSpan from "../../../shared/TimeSpan";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class ScheduleTimeView extends ViewBase implements IView {

    public _presenter: ScheduleTimePresenter;

    public showCancelSelectionButton(show, callback: Function = null) {
        const button = this.$element.querySelector("#cancel-selection");
        button.style.display = show ? 'block' : 'none';
        if (callback)
            callback();
    }

    public highlightSelection(time: TimeSpan) {
        const elements = this.$element.querySelectorAll("button[data-time]");

        for (const e of elements) {
            e.classList.add('outline');
        }

        for (const e of elements) {

            const parsed = JSON.parse(e.getAttribute('data-time'));
            const timeSpan = TimeSpan.fromString(parsed.timeValue);
            console.log(time.toString() + "  " + timeSpan.toString());
            
            if (time.toString() === timeSpan.toString()) {
                e.classList.remove('outline')
            }
        }

    }

    public setBookingTimes(times: any[]) {
        let html = ''

        for (const bookingTime of times) {
            let button = 
            `<button class="outline" data-time='${JSON.stringify(bookingTime)}' 
                style="padding:1rem 1rem;margin: 10px 10px 0px 0px;width:100%;text-align:left;">
                ${bookingTime.time}
                <span class="bi bi-arrow-right-square"></span>
            </button>`;
            html += button;
        }

        // clear out 
        const element = this.$element.querySelector("#booking-times");
        element.innerHTML = '';

        const item = document.createElement("div");
        item.innerHTML = html;

        element.append(item)
    }


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: ScheduleTimePresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    public setPresenter(presenter: ScheduleTimePresenter) {
        this._presenter = presenter;
    }

    public render(): void {
    }

}